import { MembershipLevelDto } from './dto/membership-level.dto';
import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/api/api.service';
import { IBenefitService } from './ibenefit.service';
import { MembershipLevelBenefit } from './membership-level-benefit.model';
import { ProfileBenefitSearchParams } from './profile-benefit-search-params.model';
import { MembershipLevelBenefitSearchParams } from './membership-level-benefit-search-params.model';
import { MembershipLevelBenefitSearchResult } from './membership-level-benefit-search-result.model';
import { ProfileBenefit } from './profile-benefit.model';
import { BenefitType } from './benefit-type.model';
import { BenefitFlag } from './benefit-flag.model';
import { EventPriceBenefit } from './event-price-benefit.model';
import { EventBenefit } from './event-benefit.model';
import { PagedSearch, PagedResult } from '../../shared/model/index';
import { ProfileBenefitCreateMass } from './profile-benefit-create-mass.model';
import { RenewBenefitsMass } from './renew-benefits-mass.model';

@Injectable({
  providedIn: 'root',
})
export class BenefitService implements IBenefitService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public getMembershipLevelBenefits = (search: MembershipLevelBenefitSearchParams): Promise<MembershipLevelBenefitSearchResult> => {
    //let url: string = "";
    //return this._apiService.getPaged(url, search);

    //unitl backend is built:

    let url: string = '/Membership/GetMemberTypes';
    return this._apiService.get(url);
  };

  public getProfileBenefits = (profileId: number): Promise<Array<ProfileBenefit>> => {
    let url: string = 'ProfileBenefits?PageSize=9999&ProfileIds=' + profileId.toString();
    return this._apiService.get(url).then((data: any) => {
      return Promise.resolve(data.Result);
    });
  };

  public searchProfileBenefits = (searchParams: ProfileBenefitSearchParams): Promise<PagedResult> => {
    let url: string = 'MembershipLevels/Profiles';
    if (searchParams.ActiveOnly) searchParams.Active = true;
    else searchParams.Active = null;

    return this._apiService.getPaged(url, searchParams).then((data: any) => {
      return Promise.resolve(data);
    });
  };

  public createProfileBenefit = (benefit: ProfileBenefit): Promise<number> => {
    let url: string = 'ProfileBenefits';
    return this._apiService.post(url, benefit);
  };

  public updateProfileBenefit = (benefit: ProfileBenefit): Promise<number> => {
    let url: string = 'ProfileBenefit/' + benefit.Id.toString();
    return this._apiService.put(url, benefit);
  };

  public getMemberTypes = (): Promise<Array<any>> => {
    let url: string = '/Membership/GetMemberTypes';
    return this._apiService.get(url);
  };

  public deleteProfileBenefit = (id: number): Promise<number> => {
    let url: string = 'ProfileBenefit/' + id.toString();
    return this._apiService.delete(url);
  };

  public getBenefitTypes = (): Promise<Array<BenefitType>> => {
    let url: string = '/BenefitTypes?PageSize=9999';
    return this._apiService.get(url).then((data: any) => {
      return Promise.resolve(data.Result);
    });
  };

  public getMembershipLevels = (forceRefresh = false): Promise<PagedResultGeneric<MembershipLevelDto>> => {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    let url: string = '/MembershipLevels';
    return this._apiService.getPaged(url, { PageSize: 0, PageNumber: 1 }, cacheOptions);
  };

  public getMembershipLevel = (id: number, forceRefresh: boolean): Promise<MembershipLevelDto> => {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.get(`/MembershipLevel/${id}`, cacheOptions);
  };

  public createMembershipLevel = (membershipLevel: MembershipLevelDto): Promise<number> => {
    return this._apiService.post(`/MembershipLevels/`, membershipLevel);
  };

  public deleteMembershipLevel(id: number) {
    return this._apiService.delete(`MembershipLevel/${id}`);
  }
  public updateMembershipLevel = (id: number, membershipLevel: MembershipLevelDto) => {
    return this._apiService.put(`MembershipLevel/${id}`, membershipLevel);
  };
  public updateMembershipLevelAndProfiles = (id: number, membershipLevel: any) => {
    return this._apiService.put(`/MembershipLevel/${id}/UpdateProfiles`, membershipLevel);
  };
  public renewProfileBenefits = (profileId: number): Promise<void> => {
    let url: string = 'Profile/' + profileId.toString() + '/RenewBenefits';
    return this._apiService.put(url, null);
  };

  public getEventBenefits = (eventId: number, forceRefresh?: boolean): Promise<Array<EventBenefit>> => {
    let url: string = '/Event/' + eventId.toString() + '/Benefits';
    let cacheOptions = null;
    if (forceRefresh) {
      cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    }
    return this._apiService.get(url, cacheOptions).then((data: Array<EventBenefit>) => {
      for (let benefit of data) {
        for (let item of benefit.EventItems) {
          item.Selected = true;
        }
      }

      return Promise.resolve(data);
    });
  };

  public getProfileEventBenefits = (profileId: number, eventId: number): Promise<Array<ProfileBenefit>> => {
    let url: string =
      '/ProfileBenefits?Active=true&Profileids=' + profileId.toString() + '&EventIds=' + eventId.toString() + '&PageSize=9999';
    return this._apiService.get(url).then((data: PagedResult) => {
      return Promise.resolve(data.Result);
    });
  };

  public createEventBenefit = (benefit: EventBenefit): Promise<number> => {
    let selectedEventItems = new Array<EventPriceBenefit>();
    for (let item of benefit.EventItems) {
      if (item.Selected == true) {
        selectedEventItems.push(item);
      }
    }

    benefit.EventItems = selectedEventItems;
    let url: string = '/Event/' + benefit.EventId.toString() + '/Benefits';
    return this._apiService.post(url, benefit);
  };

  public updateEventBenefit = (benefit: EventBenefit): Promise<void> => {
    let selectedEventItems = new Array<EventPriceBenefit>();
    for (let item of benefit.EventItems) {
      if (item.Selected == true) {
        selectedEventItems.push(item);
      }
    }
    benefit.EventItems = selectedEventItems;
    let url: string = '/EventBenefit/' + benefit.EventBenefitId.toString();
    return this._apiService.put(url, benefit);
  };

  public deleteEventBenefit = (eventBenefitId: number): Promise<void> => {
    let url: string = '/EventBenefit/' + eventBenefitId.toString();
    return this._apiService.delete(url);
  };

  public massCreateProfileBenefits = (
    benefit: ProfileBenefit,
    profileIds: number[],
    useDuesBillingDate: boolean,
    selectAll: boolean,
    searchParams: ProfileBenefitSearchParams
  ): Promise<number> => {
    let massCreate: ProfileBenefitCreateMass = benefit as ProfileBenefitCreateMass;
    if (!selectAll) searchParams = null;
    massCreate.ProfileIds = profileIds;
    massCreate.UseDuesBillingDate = useDuesBillingDate;

    let url: string = 'ProfileBenefitsMass';
    return this._apiService.post(url, {
      ProfileBenefitMassModel: benefit,
      SelectAll: selectAll,
      SearchModel: searchParams,
    });
  };

  public massFlagProfileBenefits = (
    benefitFlag: BenefitFlag,
    selectAll: boolean,
    searchModel: ProfileBenefitSearchParams
  ): Promise<void> => {
    if (!selectAll) searchModel = null;
    let url: string = 'FlagProfileBenefits';
    return this._apiService.post(url, {
      FlagBenefitMassModel: benefitFlag,
      SelectAll: selectAll,
      SearchModel: searchModel,
    });
  };

  public flagProfileBenefit = (benefitFlag: BenefitFlag): Promise<void> => {
    let url: string = 'FlagProfileBenefit';
    return this._apiService.post(url, benefitFlag);
  };

  public massRenewProfileBenefits = (profileIds: number[], selectAll: boolean, searchModel: ProfileBenefitSearchParams): Promise<void> => {
    let url: string = 'Profile/RenewBenefitsMass';
    let renewBenefitsMass = new RenewBenefitsMass();
    renewBenefitsMass.ProfileIds = profileIds;
    renewBenefitsMass.SelectAll = selectAll;
    if (!selectAll) searchModel = null;
    return this._apiService.post(url, {
      RenewBenefitsMass: renewBenefitsMass,
      SelectAll: selectAll,
      SearchModel: searchModel,
    });
  };
}
